import classNames from 'classnames';
import { motion } from 'motion/react';
import { MouseEventHandler, PropsWithChildren } from 'react';

interface Props {
  readonly className?: string;
  readonly onCloseCallback?: MouseEventHandler<HTMLDivElement>;
}

const Backdrop = ({
  children,
  className,
  onCloseCallback,
}: PropsWithChildren<Props>) => (
  <motion.div
    animate={{ opacity: 0.8 }}
    exit={{ opacity: 0 }}
    initial={{ opacity: 0 }}
    transition={{
      ease: 'easeInOut',
      duration: 0.3,
    }}
    key="backdrop"
    role="presentation"
    className={classNames(
      'tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-30 tw-h-screen tw-bg-black',
      className
    )}
    onClick={onCloseCallback}
  >
    {children}
  </motion.div>
);

export default Backdrop;
